import { Icon } from "../../atoms/icons";
import { Typography } from "../../atoms/typography";
import { Box } from "../../primitives";
import { iconSize } from "../../tokens";

/**
 * The line under a Form field: its error, after the warning icon, or else its
 * helper text; nothing when there's neither. Internal to the Form wrappers.
 */
export function FormFieldMessage({ error, helperText }: { error?: string; helperText?: string }) {
  if (!error && !helperText) return null;
  return (
    <Box className="gap-spacing-xs flex flex-row items-center">
      {error && (
        <Icon
          name="WarningCircle"
          size={iconSize.sm}
          weight="fill"
          className="text-luce-system-danger-default shrink-0"
        />
      )}
      <Typography
        variant="body-sm"
        color={error ? "system-danger-default" : "neutral-foreground-intermediate"}
        // A long message wraps beside the icon on iOS and Android (Form #21)
        className="min-w-0 shrink"
      >
        {error || helperText}
      </Typography>
    </Box>
  );
}
